import {
  LiveKitRealTimeAnswerType,
  LiveKitRealTimePhotosType,
  LiveKitRealTimeResult,
  LiveKitRealTimeSourceType,
  SearchResultType,
} from '@webclient/shared-types/search-result/streaming';

import { produce } from 'immer';

export default function transformMessage(
  message: LiveKitRealTimeResult,
  result: SearchResultType,
): SearchResultType {
  return produce(result, (draft) => {
    switch (message.type) {
      case 'loading-update': {
        const loadingElement = draft.loading;
        if (typeof message.stream_counter !== 'number') return;
        loadingElement.composed[message.stream_counter] = message.response;
        loadingElement.response = loadingElement.composed.join('');
        break;
      }
      case 'layout': {
        if (message.layout.answer) {
          draft.layout.answer = {
            type: 'answer',
            text: '',
            composed: [],
            ...message.layout.answer,
          };
        }
        if (message.layout.linkId) {
          draft.layout.source = {
            id: message.layout.linkId,
            source: [],
            type: 'source',
          };
        }
        if (message.layout.photos) {
          draft.layout.photo = {
            photos: [],
            type: 'photos',
            ...message.layout.photos,
          };
        }
        break;
      }
      case 'followup': {
        draft.followups = {
          followups: message.followups,
          type: 'followup',
        };
        break;
      }
      case 'update': {
        return updateLayoutResponse(message, result);
      }
      case 'tos': {
        draft.layout.answer.text = message.response;
        draft.loading.isLoading = false;
        break;
      }
      default:
        return draft;
    }
  });
}

export type StreamingUpdateType =
  | ({ history_block_id: string | null } & LiveKitRealTimeAnswerType)
  | LiveKitRealTimeSourceType
  | LiveKitRealTimePhotosType;

function updateLayoutResponse(
  message: StreamingUpdateType,
  result: SearchResultType,
) {
  return produce(result, (draft) => {
    if ('history_block_id' in message) {
      draft.historyBlockId = message.history_block_id;
    }
    switch (message.componentType) {
      case 'photos':
        draft.layout.photo = {
          type: message.componentType,
          photos: message.photos,
          id: message.id,
        };
        break;
      case 'answer': {
        const answerElement = draft.layout.answer!;
        if (draft.layout.answer.composed.length > 0) {
          draft.loading.isLoading = false;
        }
        if (typeof message.stream_counter !== 'number') return;
        answerElement.composed[message.stream_counter] = message.text;
        answerElement.text = answerElement.composed.join('');
        break;
      }
      case 'source': {
        draft.layout.source = {
          type: message.componentType,
          source: [...draft.layout.source!.source, message.source],
          id: message.id,
        };
        break;
      }
      default:
        return draft;
    }
  });
}
